<!-- Outermost main div wrapper -->
<div class="min-h-screen p-6 md:p-8 bg-slate-50 dark:bg-slate-900 transition-colors duration-300 overflow-y-auto custom-scrollbar">

  <!-- Header Section -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
    <div>
      <h1 class="text-2xl font-black text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500 text-3xl">receipt_long</span>
        หน้าจำลองทดสอบใบแจ้งหนี้ (Invoice Mockup Sandbox)
      </h1>
      <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">ใช้ทดสอบ UI ระบบตัวกรอง แอนิเมชัน กราฟ และฟังก์ชันอัตโนมัติตามกฎมาตรฐาน</p>
    </div>

    <!-- Top Toolbar Controls -->
    <div class="flex flex-wrap items-center gap-3">
      <!-- Simulated Add Button -->
      <button (click)="addMockInvoice()"
        class="px-5 py-2.5 bg-amber-400 text-slate-950 rounded-xl shadow-lg shadow-amber-400/20 hover:bg-amber-500 hover:-translate-y-0.5 transition-all duration-300 font-bold flex items-center gap-2 active:scale-95">
        <span class="material-icons">add_circle</span>
        <span>จำลองเพิ่มใบแจ้งหนี้</span>
      </button>

      <!-- Toggle Dashboard Button -->
      <button (click)="toggleDashboard()"
        class="px-4 py-2.5 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 rounded-xl shadow-sm border border-slate-200/80 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:border-amber-400 dark:hover:border-amber-500 transition-all flex items-center gap-2 active:scale-95">
        <span class="material-icons text-lg">{{ showDashboard ? 'expand_less' : 'expand_more' }}</span>
        <span class="text-xs font-bold">{{ showDashboard ? 'ซ่อนกราฟสถิติ' : 'แสดงกราฟสถิติ' }}</span>
      </button>

      <!-- Refresh Button -->
      <button (click)="onRefresh()"
        class="p-2.5 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200/80 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:border-amber-400 dark:hover:border-amber-500 transition-all active:scale-95 flex items-center justify-center"
        title="รีเฟรชข้อมูลทั้งหมด">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <!-- Collapsible Analytics Dashboard -->
  <div *ngIf="showDashboard" class="animate-fade-in-up mb-8 grid grid-cols-1 lg:grid-cols-4 gap-6">

    <!-- KPI Stats Cards Grid (3/4 of the width on lg screens) -->
    <div class="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
      
      <!-- Total Invoiced Card -->
      <div class="group bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl p-5 shadow-xl hover:shadow-2xl transition-all duration-300 relative overflow-hidden">
        <div class="absolute -right-4 -bottom-4 w-16 h-16 rounded-full opacity-10 bg-indigo-500 transition-transform duration-300 group-hover:scale-150"></div>
        <div class="flex items-center justify-between relative z-10">
          <div>
            <p class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">ยอดรวมใบเสนอราคา</p>
            <h3 class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">฿{{ totalAmount | number:'1.2-2' }}</h3>
            <p class="text-[10px] font-semibold text-indigo-500 mt-2">ยอดใบแจ้งหนี้ฟิลเตอร์</p>
          </div>
          <div class="p-3 rounded-xl bg-indigo-50 dark:bg-indigo-950/30 text-indigo-500 transition-transform duration-300 group-hover:scale-110">
            <span class="material-icons text-2xl">receipt_long</span>
          </div>
        </div>
      </div>

      <!-- Paid Card -->
      <div class="group bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl p-5 shadow-xl hover:shadow-2xl transition-all duration-300 relative overflow-hidden">
        <div class="absolute -right-4 -bottom-4 w-16 h-16 rounded-full opacity-10 bg-emerald-500 transition-transform duration-300 group-hover:scale-150"></div>
        <div class="flex items-center justify-between relative z-10">
          <div>
            <p class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">ชำระแล้ว</p>
            <h3 class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">฿{{ paidAmount | number:'1.2-2' }}</h3>
            <p class="text-[10px] font-semibold text-emerald-500 mt-2">รับเงินเรียบร้อย</p>
          </div>
          <div class="p-3 rounded-xl bg-emerald-50 dark:bg-emerald-950/30 text-emerald-500 transition-transform duration-300 group-hover:scale-110">
            <span class="material-icons text-2xl">check_circle</span>
          </div>
        </div>
      </div>

      <!-- Pending Card -->
      <div class="group bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl p-5 shadow-xl hover:shadow-2xl transition-all duration-300 relative overflow-hidden">
        <div class="absolute -right-4 -bottom-4 w-16 h-16 rounded-full opacity-10 bg-amber-500 transition-transform duration-300 group-hover:scale-150"></div>
        <div class="flex items-center justify-between relative z-10">
          <div>
            <p class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">รอชำระ</p>
            <h3 class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">฿{{ pendingAmount | number:'1.2-2' }}</h3>
            <p class="text-[10px] font-semibold text-amber-500 mt-2">อยู่ระหว่างเครดิตเทอม</p>
          </div>
          <div class="p-3 rounded-xl bg-amber-50 dark:bg-amber-950/30 text-amber-500 transition-transform duration-300 group-hover:scale-110">
            <span class="material-icons text-2xl">pending_actions</span>
          </div>
        </div>
      </div>

      <!-- Overdue Card -->
      <div class="group bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl p-5 shadow-xl hover:shadow-2xl transition-all duration-300 relative overflow-hidden">
        <div class="absolute -right-4 -bottom-4 w-16 h-16 rounded-full opacity-10 bg-red-500 transition-transform duration-300 group-hover:scale-150"></div>
        <div class="flex items-center justify-between relative z-10">
          <div>
            <p class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">เกินกำหนดชำระ</p>
            <h3 class="text-xl font-black text-red-600 dark:text-red-400 mt-1">฿{{ overdueAmount | number:'1.2-2' }}</h3>
            <p class="text-[10px] font-semibold text-red-500 mt-2">ต้องติดตามทวงถาม</p>
          </div>
          <div class="p-3 rounded-xl bg-red-50 dark:bg-red-950/30 text-red-500 transition-transform duration-300 group-hover:scale-110">
            <span class="material-icons text-2xl">error_outline</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Circular Progress SVG (Ratio Chart) (1/4 of width on lg screens) -->
    <div class="bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl p-5 shadow-xl flex flex-col items-center justify-center text-center relative overflow-hidden">
      <h4 class="text-xs font-bold text-slate-700 dark:text-slate-300 mb-3">อัตราการชำระเงินสำเร็จ</h4>
      
      <div class="relative flex items-center justify-center w-28 h-28">
        <svg class="w-full h-full transform -rotate-90">
          <!-- Background track circle -->
          <circle cx="56" cy="56" r="46" stroke="currentColor" stroke-width="8" class="text-slate-100 dark:text-slate-700" fill="transparent" />
          <!-- Foreground active indicator -->
          <circle cx="56" cy="56" r="46" stroke="currentColor" stroke-width="8" 
            class="text-amber-400 transition-all duration-700 ease-out" fill="transparent"
            [attr.stroke-dasharray]="289" [attr.stroke-dashoffset]="289 - (paidRatioPercent / 100 * 289)" />
        </svg>
        <span class="absolute text-xl font-black text-slate-800 dark:text-slate-100">{{ paidRatioPercent }}%</span>
      </div>

      <p class="text-[10px] text-slate-400 dark:text-slate-500 mt-3">สัดส่วนยอดเงินชำระเสร็จสิ้นเทียบกับทั้งหมด</p>
    </div>

    <!-- Trend Line / Bar Chart (Spans full width) -->
    <div class="lg:col-span-4 bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl p-6 shadow-xl relative overflow-hidden">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
        <div>
          <h4 class="text-sm font-black text-slate-800 dark:text-slate-100">กราฟแนวโน้มจำนวนใบเสนอราคา/ใบแจ้งหนี้</h4>
          <p class="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5">รวมในกราฟ: {{ chartTotalCount }} รายการ</p>
        </div>

        <div class="flex items-center gap-3">
          <!-- Mode Toggle (Daily / Monthly) -->
          <div class="flex bg-slate-100 dark:bg-slate-900 p-0.5 rounded-lg border border-slate-200/50 dark:border-slate-800">
            <button (click)="setChartMode('daily')" 
              [class]="chartMode === 'daily' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 dark:text-slate-400'"
              class="px-3 py-1 text-[10px] font-bold rounded-md transition-all">
              รายวัน (7 วันล่าสุด)
            </button>
            <button (click)="setChartMode('monthly')" 
              [class]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 dark:text-slate-400'"
              class="px-3 py-1 text-[10px] font-bold rounded-md transition-all">
              รายเดือน (6 เดือนล่าสุด)
            </button>
          </div>

          <!-- Type Toggle (Line / Bar) -->
          <div class="flex bg-slate-100 dark:bg-slate-900 p-0.5 rounded-lg border border-slate-200/50 dark:border-slate-800">
            <button (click)="setChartType('line')" 
              [class]="chartType === 'line' ? 'bg-white dark:bg-slate-700 text-amber-500' : 'text-slate-500 dark:text-slate-400'"
              class="p-1 rounded-md transition-all flex items-center" title="กราฟเส้น">
              <span class="material-icons text-sm">show_chart</span>
            </button>
            <button (click)="setChartType('bar')" 
              [class]="chartType === 'bar' ? 'bg-white dark:bg-slate-700 text-amber-500' : 'text-slate-500 dark:text-slate-400'"
              class="p-1 rounded-md transition-all flex items-center" title="กราฟแท่ง">
              <span class="material-icons text-sm">bar_chart</span>
            </button>
          </div>
        </div>
      </div>

      <!-- SVG Chart Canvas Area -->
      <div class="relative w-full h-44 mt-2">
        <svg class="w-full h-full overflow-visible" viewBox="0 0 100 100" preserveAspectRatio="none">
          <!-- Grid Lines -->
          <line *ngFor="let label of yAxisLabels; let i = index" x1="2" [attr.y1]="90 - (i * 20)" x2="98" [attr.y2]="90 - (i * 20)" stroke="currentColor" class="text-slate-100 dark:text-slate-800" stroke-width="0.5" stroke-dasharray="2 2" />

          <!-- Line Gradient fill area -->
          <path *ngIf="chartType === 'line' && chartAreaPathStr" [attr.d]="chartAreaPathStr" fill="url(#yellowChartGrad)" class="opacity-10 transition-all duration-500 ease-out" />

          <!-- Line curve path -->
          <path *ngIf="chartType === 'line' && chartPathStr" [attr.d]="chartPathStr" fill="none" stroke="#fbbf24" stroke-width="1.5" stroke-linecap="round" filter="url(#glowFilter)" class="transition-all duration-500 ease-out" />

          <!-- Bar Chart rectangles -->
          <g *ngIf="chartType === 'bar'">
            <rect *ngFor="let dot of chartDots; let i = index" [attr.x]="dot.x - 2" [attr.y]="dot.y" width="4" [attr.height]="90 - dot.y" fill="#fbbf24" rx="1" class="transition-all duration-500 ease-out hover:fill-amber-500" />
          </g>

          <!-- Defs definitions -->
          <defs>
            <linearGradient id="yellowChartGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color="#fbbf24" />
              <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
            </linearGradient>
            <filter id="glowFilter" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="0" dy="2" stdDeviation="1.5" flood-color="#fbbf24" flood-opacity="0.3" />
            </filter>
          </defs>
        </svg>

        <!-- Tooltip points for curves -->
        <div *ngFor="let dot of chartDots" [style.left.%]="dot.x" [style.top.%]="dot.y" class="absolute -translate-x-1/2 -translate-y-1/2 group z-10">
          <div *ngIf="chartType === 'line'" class="w-3 h-3 bg-white border-2 border-amber-400 rounded-full cursor-pointer hover:scale-125 transition-all shadow-md"></div>
          
          <!-- Tooltip Popup -->
          <div class="opacity-0 group-hover:opacity-100 transition-opacity bg-slate-800 text-white text-[9px] font-bold py-1 px-2 rounded-lg absolute bottom-full left-1/2 -translate-x-1/2 -translate-y-2 whitespace-nowrap shadow-lg pointer-events-none">
            {{ dot.value }} รายการ
          </div>
        </div>
      </div>

      <!-- X Axis labels -->
      <div class="flex justify-between px-2 mt-2 border-t border-slate-100 dark:border-slate-800 pt-2 text-[9px] font-bold text-slate-400 dark:text-slate-500">
        <div *ngFor="let dot of chartDots" class="text-center w-12 flex flex-col items-center">
          <span>{{ dot.label }}</span>
        </div>
      </div>

    </div>

  </div>

  <!-- Table Section -->
  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-[2rem] shadow-2xl p-6 relative overflow-hidden backdrop-blur-sm">
    
    <!-- Table Control Bar -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
      
      <!-- Search Input Group with Dropdown -->
      <div class="flex items-center bg-slate-100/80 dark:bg-slate-900/80 border border-slate-200/50 dark:border-slate-700/50 rounded-xl px-3 py-1.5 focus-within:ring-2 focus-within:ring-amber-400/50 focus-within:border-amber-400 w-full md:max-w-md transition-all">
        <span class="material-icons text-slate-400 mr-2">search</span>
        
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
          [placeholder]="'ค้นหาด้วย ' + currentSearchTypeLabel + '...'"
          class="w-full bg-transparent border-none outline-none text-sm text-slate-700 dark:text-slate-200 placeholder-slate-400 font-medium" />

        <!-- Dropdown Selector -->
        <div class="relative ml-2 border-l border-slate-300 dark:border-slate-700 pl-2">
          <button (click)="toggleSearchTypeDropdown()"
            class="flex items-center gap-1 text-xs font-bold text-slate-500 hover:text-slate-800 dark:hover:text-slate-200">
            <span>{{ currentSearchTypeLabel }}</span>
            <span class="material-icons text-sm">arrow_drop_down</span>
          </button>

          <div *ngIf="isSearchTypeDropdownOpen"
            class="absolute right-0 mt-2 z-30 w-44 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl shadow-xl py-1">
            <button (click)="selectSearchType('customerName')"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700">ชื่อลูกค้า</button>
            <button (click)="selectSearchType('invoiceNo')"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700">เลขที่ใบแจ้งหนี้</button>
          </div>
        </div>
      </div>

      <!-- Advanced Filter Toggle Button -->
      <button (click)="toggleTableFilters()" [class.bg-amber-400]="showTableFilters"
        [class.text-slate-950]="showTableFilters" [class.border-amber-400]="showTableFilters"
        class="flex items-center justify-center gap-2 px-5 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-750 transition-all shadow-sm">
        <span class="material-icons text-lg">filter_list</span>
        ตัวกรองขั้นสูง
      </button>

    </div>

    <!-- Advanced Horizontal Collapsible Filter Panel -->
    <div *ngIf="showTableFilters"
      class="p-5 bg-slate-50/50 dark:bg-slate-900/30 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl mb-6 grid grid-cols-1 md:grid-cols-3 gap-6 animate-fade-in">

      <!-- Custom Combobox Autocomplete for Customer Name -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400">กรองตามชื่อลูกค้า</label>
        <div class="relative w-full">
          <div
            class="flex items-center w-full px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl focus-within:ring-2 focus-within:ring-amber-400/50">
            <input type="text" [(ngModel)]="searchFieldText" (focus)="toggleCustomerDropdown()"
              (blur)="closeDropdowns()" placeholder="พิมพ์เพื่อค้นหาลูกค้า..."
              class="w-full bg-transparent outline-none text-slate-750 dark:text-slate-200 text-sm font-semibold placeholder-slate-400" />

            <button *ngIf="selectedCustomerFilter !== 'all'"
              (click)="clearCustomerSelection(); $event.stopPropagation()"
              class="material-icons text-slate-400 hover:text-slate-600 text-sm cursor-pointer mr-1">clear</button>
            
            <span class="material-icons text-slate-400 cursor-pointer"
              (click)="toggleCustomerDropdown()">arrow_drop_down</span>
          </div>

          <!-- Dropdown Autocomplete Panel -->
          <div *ngIf="isCustomerDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute z-50 w-full mt-1.5 bg-white/95 dark:bg-slate-800/95 border border-slate-150 dark:border-slate-700 rounded-xl shadow-xl max-h-48 overflow-y-auto custom-scrollbar backdrop-blur-sm">
            <div *ngIf="filteredOptions.length === 0" class="px-4 py-3 text-xs text-slate-400 text-center">
              ไม่พบรายชื่อลูกค้า
            </div>
            <div *ngFor="let opt of filteredOptions" (click)="selectCustomerOption(opt)"
              class="px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-350 hover:bg-amber-50 dark:hover:bg-amber-950/20 hover:text-amber-600 cursor-pointer transition-colors duration-150">
              {{ opt }}
            </div>
          </div>
        </div>
      </div>

      <!-- Angular Material Datepicker Range Selection -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400">วันที่เริ่มต้น - วันที่สิ้นสุด</label>
        <div class="flex items-center gap-2 px-4 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl">
          <mat-date-range-input [rangePicker]="picker" class="text-sm font-semibold text-slate-700 dark:text-slate-300 w-full">
            <input matStartDate [(ngModel)]="startDate" (dateChange)="onDateChange()" placeholder="เริ่มต้น">
            <input matEndDate [(ngModel)]="endDate" (dateChange)="onDateChange()" placeholder="สิ้นสุด">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker" class="text-slate-400 hover:text-amber-500"></mat-datepicker-toggle>
          <mat-date-range-picker #picker panelClass="modern-yellow-datepicker"></mat-date-range-picker>
        </div>
      </div>

      <!-- Status dropdown -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400">สถานะ</label>
        <div class="relative">
          <select [(ngModel)]="filterStatus" (change)="onFilterChange()"
            class="w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl text-sm font-semibold text-slate-700 dark:text-slate-300 outline-none focus:ring-2 focus:ring-amber-400/50 appearance-none cursor-pointer">
            <option value="all">ทั้งหมด</option>
            <option [value]="1">รอชำระ</option>
            <option [value]="2">ชำระแล้ว</option>
            <option [value]="3">ยกเลิก</option>
            <option [value]="4">เกินกำหนด</option>
          </select>
          <span class="material-icons absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">arrow_drop_down</span>
        </div>
      </div>

    </div>

    <!-- Table Core -->
    <div class="overflow-x-auto rounded-xl border border-slate-100/50 dark:border-slate-700/50 custom-scrollbar mb-6">
      <table class="w-full border-collapse text-left text-sm">
        <thead>
          <tr class="bg-slate-50/80 dark:bg-slate-900/80 text-slate-400 dark:text-slate-500 border-b border-slate-100 dark:border-slate-700 text-xs font-bold uppercase tracking-wider">
            <th (click)="sortData('invoiceNo')" class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/50 transition-colors select-none">
              เลขที่ใบแจ้งหนี้
              <span class="material-icons text-sm align-middle ml-1 text-amber-500" *ngIf="sortColumn === 'invoiceNo'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th (click)="sortData('customerName')" class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/50 transition-colors select-none">
              ลูกค้า / บริษัท
              <span class="material-icons text-sm align-middle ml-1 text-amber-500" *ngIf="sortColumn === 'customerName'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="px-6 py-4">เลขประจำตัวผู้เสียภาษี</th>
            <th (click)="sortData('invoiceDate')" class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/50 transition-colors select-none text-center">
              วันที่ออก
              <span class="material-icons text-sm align-middle ml-1 text-amber-500" *ngIf="sortColumn === 'invoiceDate'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th (click)="sortData('total')" class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/50 transition-colors select-none text-right">
              จำนวนเงินรวม (บาท)
              <span class="material-icons text-sm align-middle ml-1 text-amber-500" *ngIf="sortColumn === 'total'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="px-6 py-4 text-center">สถานะ</th>
            <th class="px-6 py-4 text-center">ดำเนินการ (สลับสถานะ / ยกเลิก)</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-slate-700/80 text-sm">
          <tr *ngIf="paginatedData.length === 0" class="hover:bg-slate-50/50 dark:hover:bg-slate-900/20">
            <td colspan="7" class="px-6 py-10 text-center text-slate-400 dark:text-slate-500 font-medium">
              <span class="material-icons text-3xl block mb-2 text-slate-300 dark:text-slate-600">receipt</span>
              ไม่พบข้อมูลใบแจ้งหนี้
            </td>
          </tr>

          <tr *ngFor="let item of paginatedData" class="hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors duration-150">
            <td class="px-6 py-4 font-bold text-slate-800 dark:text-slate-200">{{ item.invoiceNo }}</td>
            <td class="px-6 py-4">
              <div class="font-bold text-slate-700 dark:text-slate-250">{{ item.customerName }}</div>
              <div class="text-xs text-slate-400 dark:text-slate-500 truncate max-w-xs mt-0.5" [title]="item.address">{{ item.address }}</div>
            </td>
            <td class="px-6 py-4">
              <div class="font-semibold text-slate-700 dark:text-slate-300">{{ item.taxId }}</div>
              <div class="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5">สาขา: {{ item.branchNo || '-' }}</div>
            </td>
            <td class="px-6 py-4 text-center font-medium text-slate-600 dark:text-slate-400">{{ formatDateDisplay(item.invoiceDate) }}</td>
            <td class="px-6 py-4 text-right font-black text-slate-800 dark:text-slate-200">
              {{ (item.fee + item.vat) | number:'1.2-2' }}
            </td>
            <td class="px-6 py-4 text-center">
              <span class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-black border shadow-sm"
                [ngClass]="getStatusConfig(item.status).class">
                <span class="material-icons text-[14px]" [ngClass]="getStatusConfig(item.status).iconClass">{{ getStatusConfig(item.status).icon }}</span>
                {{ getStatusConfig(item.status).label }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">
              <div class="flex items-center justify-center gap-2">
                <!-- Action toggle status -->
                <button (click)="toggleInvoiceStatus(item, $event)"
                  class="inline-flex items-center gap-1 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-xs font-bold text-slate-700 dark:text-slate-250 rounded-lg shadow-sm transition-all"
                  title="สลับสถานะจำลอง">
                  <span class="material-icons text-sm">autorenew</span>
                  <span>สลับสถานะ</span>
                </button>

                <!-- Cancel button -->
                <button *ngIf="item.status !== 3" (click)="openCancelConfirm(item, $event)"
                  class="inline-flex items-center gap-1 px-3 py-1.5 bg-rose-500 hover:bg-rose-600 text-xs font-bold text-white rounded-lg shadow-sm transition-all"
                  title="ยกเลิกใบแจ้งหนี้">
                  <span class="material-icons text-sm">cancel</span>
                  <span>ยกเลิก</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
      
      <!-- Left: Thai item count text -->
      <p class="text-xs font-bold text-slate-500 dark:text-slate-400">
        แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems }} รายการ
      </p>

      <!-- Center / Right -->
      <div class="flex items-center gap-4 flex-wrap">
        <!-- Page size selector dropdown -->
        <div class="flex items-center gap-2">
          <span class="text-xs font-bold text-slate-500 dark:text-slate-400">ขนาดหน้า:</span>
          <div class="relative">
            <select [(ngModel)]="pageSize" (change)="onPageSizeChange()"
              class="bg-slate-100 dark:bg-slate-900 text-xs font-bold text-slate-700 dark:text-slate-300 px-3 py-1.5 rounded-lg border-none outline-none focus:ring-1 focus:ring-amber-400 appearance-none pr-6 cursor-pointer">
              <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
            </select>
            <span class="material-icons absolute right-1.5 top-1/2 -translate-y-1/2 text-slate-500 text-sm pointer-events-none">arrow_drop_down</span>
          </div>
        </div>

        <!-- Pagination number buttons -->
        <div class="flex items-center gap-1">
          <!-- Prev Button -->
          <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
            class="w-8 h-8 rounded-lg bg-slate-100 dark:bg-slate-900 text-slate-650 disabled:opacity-40 hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors flex items-center justify-center cursor-pointer">
            <span class="material-icons text-sm">chevron_left</span>
          </button>

          <!-- Number buttons -->
          <button *ngFor="let page of pagesArray" (click)="setPage(page)"
            [class.bg-amber-400]="page === currentPage"
            [class.text-slate-950]="page === currentPage"
            [class.font-black]="page === currentPage"
            [class.bg-slate-100]="page !== currentPage"
            [class.dark:bg-slate-900]="page !== currentPage"
            [class.text-slate-600]="page !== currentPage"
            [class.dark:text-slate-350]="page !== currentPage"
            class="w-8 h-8 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-800 transition-all flex items-center justify-center text-xs font-bold shadow-sm cursor-pointer">
            {{ page }}
          </button>

          <!-- Next Button -->
          <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
            class="w-8 h-8 rounded-lg bg-slate-100 dark:bg-slate-900 text-slate-650 disabled:opacity-40 hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors flex items-center justify-center cursor-pointer">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>

    </div>

  </div>

</div>

<!-- Glassmorphism Confirmation Modal (Cancel Invoice) -->
<div *ngIf="isConfirmModalOpen"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-md bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-3xl shadow-2xl overflow-hidden p-6 flex flex-col items-center text-center animate-fade-in-up">
    
    <div class="w-16 h-16 rounded-full bg-rose-50 dark:bg-rose-950/20 text-rose-500 flex items-center justify-center mb-4 shadow-inner">
      <span class="material-icons text-3xl">warning</span>
    </div>

    <h3 class="text-lg font-black text-slate-800 dark:text-slate-100 mb-2">ยืนยันการยกเลิกใบแจ้งหนี้</h3>
    
    <p class="text-sm text-slate-500 dark:text-slate-400 mb-6" *ngIf="selectedInvoiceForCancel">
      คุณต้องการยกเลิกใบแจ้งหนี้เลขที่ <span class="text-rose-500 font-bold">{{ selectedInvoiceForCancel.invoiceNo }}</span> ของลูกค้า <span class="font-bold text-slate-800 dark:text-slate-200">{{ selectedInvoiceForCancel.customerName }}</span> ใช่หรือไม่? <br>
      <span class="text-xs text-slate-400 mt-2 block">(การดำเนินการนี้ไม่สามารถย้อนกลับได้)</span>
    </p>

    <!-- Modal actions -->
    <div class="flex items-center gap-3 w-full">
      <button (click)="closeCancelConfirm()" [disabled]="isProcessingAction"
        class="flex-1 py-2.5 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-650 text-slate-700 dark:text-slate-200 text-sm font-bold rounded-xl transition-all shadow-sm">
        ปิดหน้าต่าง
      </button>
      <button (click)="confirmCancelInvoice()" [disabled]="isProcessingAction"
        class="flex-1 py-2.5 bg-rose-500 hover:bg-rose-600 disabled:opacity-50 text-white text-sm font-bold rounded-xl transition-all shadow-sm flex items-center justify-center gap-1.5">
        <span class="material-icons text-sm animate-spin" *ngIf="isProcessingAction">autorenew</span>
        <span>ยืนยันยกเลิก</span>
      </button>
    </div>

  </div>
</div>

<!-- Full Screen Loading Overlay (placed OUTSIDE the outermost main div wrapper as per Rule 2) -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>
